class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.stickyHeader = this.closest('sticky-header');

    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.hoverMedia = window.matchMedia('(min-width: 990px)');
      this.closeTimeout = null;
      this.mainDetailsToggle.addEventListener('mouseenter', this.openOnHover.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.closeOnHover.bind(this));
    }
  }

  openOnHover() {
    if (!this.hoverMedia?.matches) return;

    this.cancelCloseOnHover();
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeOnHover() {
    if (!this.hoverMedia?.matches) return;

    this.closeTimeout = setTimeout(() => {
      if (!this.matches(':hover')) this.close();
    }, 300);
  }

  cancelCloseOnHover() {
    if (!this.closeTimeout) return;

    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  close() {
    this.cancelCloseOnHover();
    super.close();
  }

  onToggle() {
    super.onToggle();

    if (this.stickyHeader) {
      this.stickyHeader.preventHide = this.mainDetailsToggle.open;
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor((this.header || this).getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
